module.exports = __webpack_public_path__ + "static/media/image-add-bg.200bc152.jpg";